import IconButton from 'components/common/IconButton';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ButtonDelete = ({
  funcion,
  data,
  className,
  style,
  disabled,
  text,
  justify,
  tooltipPosition,
  ...rest
}) => {
  return text ? (
    <Button
      className={
        className + ' d-flex align-items-center justify-content-center'
      }
      variant={!disabled ? 'danger' : 'secondary'}
      size="sm"
      disabled={disabled}
      onClick={data ? () => funcion(data) : funcion}
      type="submit"
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <div
        className={`w-100 d-flex align-items-center justify-content-${justify} gap-1`}
      >
        <FontAwesomeIcon icon="trash-can" style={{ marginRight: 5 }} />
        <span style={{ marginRight: 10 }}>{text}</span>
      </div>
    </Button>
  ) : (
    <OverlayTrigger
      placement={tooltipPosition || 'bottom'}
      overlay={<Tooltip>Eliminar</Tooltip>}
    >
      <span>
        <IconButton
          buttonSize="sm"
          style={{ width: text ? '' : 30, ...style }}
          icon="trash-can"
          onClick={
            !disabled ? (data ? () => funcion(data) : funcion) : () => {}
          }
          variant="danger"
          className={'px-2' + ' ' + className}
          disabled={disabled}
          {...rest}
        >
          {text}
        </IconButton>
      </span>
    </OverlayTrigger>
  );
};

ButtonDelete.propTypes = {
  funcion: PropTypes.func.isRequired,
  data: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  justify: PropTypes.oneOf(['start', 'center', 'end']),
  tooltipPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
};

ButtonDelete.defaultProps = {
  justify: 'center'
};

export default ButtonDelete;
